import { isBefore } from 'date-fns';

import { DatePickerDate } from '../types';

export default function isSelectable({
  minDate,
  maxDate,
  date,
}: {
  minDate?: DatePickerDate | null;
  maxDate?: DatePickerDate | null;
  date: DatePickerDate;
}) {
  if (
    (minDate && isBefore(date, minDate)) ||
    (maxDate && isBefore(maxDate, date))
  ) {
    return false;
  }
  return true;
}
